<template>
  <div>
    <van-popup
      v-model="$store.state.showPopup"
      :class="`${$store.state.xiazApp ? 'popup-conter-app' : 'popup-conter'}`"
      @close="SuporteIs = false"
      :overlay-class="`${$store.state.xiazApp ? 'popup-box-app' : 'popup-box'}`"
      position="left"
    >
      <div
        class="my-scrollbar my-scrollbar-none"
        style="width: 3rem; overflow-x: scroll"
      >
        <div
          v-if="config.ui_version == '3.6'"
          class="X_tOtMUxMTenSfTn7J28 game-menu__items"
          style="padding-top: 0.1rem"
        >
          <div
            v-if="!is_vuex_token || (is_vuex_token && item.textName != '_Demo')"
            @click="tabFun(index)"
            :class="
              $store.state.active == index
                ? 'O8zRRZalAqyl6XRHwyev ia6woxHBwCJOiUSohzV6 game-menu__item'
                : ' O8zRRZalAqyl6XRHwyev game-menu__item'
            "
            v-for="(item, index) in iconList"
            style="padding-top: 0.08rem"
            :key="index"
          >
            <img
              :src="item.svg"
              alt=""
              style="width: 0.38rem"
              class="JGYMaLsdGfKSq3qags9Y"
            />
            <div class="IDcevVi1oQJGuthlvopy text">
              {{ $t('popup.nav')[index].title }}
            </div>
            <div class="pendant-a1lbS" v-if="$store.state.active == index">
              <div
                class="pendant-lt-Pb8Fs"
                v-if="config.festival_img.button_1 != '#'"
                :style="{
                  'background-image': `url(${config.festival_img.button_1})`
                }"
                style="width: 0.4rem; height: 0.4rem"
              ></div>
              <div
                class="pendant-rb-trhWq"
                v-if="config.festival_img.button_2 != '#'"
                :style="{
                  'background-image': `url(${config.festival_img.button_2})`
                }"
                style="width: 0.4rem; height: 0.4rem"
              ></div>
            </div>
          </div>
        </div>
        <div v-else-if="config.ui_version == '3.1'" style="padding-top: 0.1rem">
          <div
            class="_search-board_1lojg_30"
            @click="$router.push({ name: 'search' })"
          >
            <span class="_text_1lojg_39">Pesquisar</span>
            <svg-icon
              className="fs20"
              style="
                color: var(--theme-text-color);
                width: 0.22rem;
                height: 0.22rem;
                margin-right: 0.2rem;
              "
              icon-class="comm_icon_ss--svgSprite:all"
            />
          </div>
          <div class="X_tOtMUxMTenSfTn7J28 game-menu__items">
            <div
              v-if="
                !$store.state.config.category_hide.includes(item.textName) &&
                (!is_vuex_token || (is_vuex_token && item.textName != '_Demo'))
              "
              @click="tabFun(index)"
              :class="
                $store.state.active == index
                  ? 'O8zRRZalAqyl6XRHwyev game-menu__item'
                  : 'O8zRRZalAqyl6XRHwyev game-menu__item'
              "
              v-for="(item, index) in iconList"
              :key="index"
            >
              <img
                :src="activeList[index]"
                alt=""
                class="JGYMaLsdGfKSq3qags9Y"
              />
              <div class="IDcevVi1oQJGuthlvopy text">
                {{ $t('popup.nav_31')[index].title }}
              </div>
            </div>
          </div>
        </div>

        <div v-else class="X_tOtMUxMTenSfTn7J28 game-menu__items">
          <div
            v-if="!is_vuex_token || (is_vuex_token && item.textName != '_Demo')"
            @click="tabFun(index)"
            :class="
              $store.state.active == index
                ? 'O8zRRZalAqyl6XRHwyev ia6woxHBwCJOiUSohzV6 game-menu__item'
                : ' O8zRRZalAqyl6XRHwyev game-menu__item'
            "
            v-for="(item, index) in iconList"
            :key="index"
          >
            <svg-icon
              v-if="$store.state.active != index"
              className="JGYMaLsdGfKSq3qags9Y"
              :icon-class="item.svg"
            />
            <img
              v-else
              :src="activeList[index]"
              alt=""
              class="JGYMaLsdGfKSq3qags9Y"
            />
            <div class="IDcevVi1oQJGuthlvopy text">
              {{ $t('popup.nav')[index].title }}
            </div>
          </div>
        </div>
        <div class="vsmXMvkgXQ1ZupbTcU60">
          <Audio v-if="$store.state.config.ui_version != '3.1'"></Audio>
          <!-- {{_vuex_token()}} -->
          <!-- .is_vuex_token -->
          <!-- @click="" -->
          <div
            @click="
              is_vuex_token
                ? $router.push({ name: 'report' })
                : $store.commit('isRecord'),
                $store.commit('publicFun', ['isRecordType', 1])
            "
            class="JzmqmQEmD_EojrBge1qC yhSUVDFwjkr5PRBtBCUM betting-record"
          >
            <svg-icon
              className="JzmqmQEmD_EojrBge1qC_iam"
              icon-class="icon_sy_zc_tzjl--svgSprite:all"
            />
            {{ $t('popup._Apostas') }}
            <!--  -->
          </div>
          <div
            @click="$router.push({ name: 'promote' })"
            class="JzmqmQEmD_EojrBge1qC yhSUVDFwjkr5PRBtBCUM betting-record"
          >
            <svg-icon
              className="JzmqmQEmD_EojrBge1qC_iam"
              icon-class="icon_sy_zc_tgzq--svgSprite:all"
            />
            {{ $t('popup._Agente') }}
          </div>

          <div class="yfF9WZOWUEDWBJAnHyPf items">
            <div class="a6z38LxCJRwWacRIx6d9 event-title">
              <span>{{ $t('popup._Promoção') }}</span>
            </div>
            <div
              @click="$router.push({ name: 'event' })"
              class="_037LxwuCKN9WUGgvrvgg item Xx6KWL671rTVnrm7j3in"
            >
              <img
                src="./../../assets/icons/images/btn_sy_zc_hd.webp"
                style="height: 0.8rem"
              />
              <span>{{ $t('popup._Eventos') }}</span>
            </div>

            <div
              @click="$router.push({ name: 'canReceive' })"
              class="_037LxwuCKN9WUGgvrvgg item Xx6KWL671rTVnrm7j3in"
            >
              <img
                src="./../../assets/icons/images/btn_sy_zc_jl.webp"
                style="height: 0.8rem"
              />
              <span>{{ $t('popup._Pendente') }}</span>
            </div>

            <div
              @click="$router.push({ name: 'records' })"
              class="_037LxwuCKN9WUGgvrvgg item Xx6KWL671rTVnrm7j3in"
            >
              <img
                src="./../../assets/icons/images/btn_sy_zc_lqjl.webp"
                style="height: 0.8rem"
              />
              <span>{{ $t('popup._Histórico') }}</span>
            </div>
            <div
              @click="$router.push({ name: 'rechargeFund' })"
              class="_037LxwuCKN9WUGgvrvgg item Xx6KWL671rTVnrm7j3in"
            >
              <img
                src="./../../assets/icons/images/btn_sy_zc_gjj.webp"
                style="height: 0.8rem"
              />
              <span>{{ $t('popup._FundodePrevidência') }}</span>
            </div>

            <div
              @click="$router.push({ name: 'yuebao' })"
              class="_037LxwuCKN9WUGgvrvgg item Xx6KWL671rTVnrm7j3in"
            >
              <img
                src="./../../assets/icons/images/btn_sy_zc_yeb.webp"
                style="height: 0.8rem"
              />
              <span>{{ $t('popup._Juros') }}</span>
            </div>
            <div
              @click="$router.push({ name: 'vip' })"
              class="_037LxwuCKN9WUGgvrvgg item Xx6KWL671rTVnrm7j3in"
            >
              <img
                src="./../../assets/icons/images/btn_sy_zc_vip.webp"
                style="height: 0.8rem"
              />
              <span>{{ $t('popup._VIP') }}</span>
            </div>
          </div>

          <div class="yVxgEnjFwfNHfoePIA4w other-group">
            <div
              id="sss"
              @click="SuporteIs = !SuporteIs"
              class="yhSUVDFwjkr5PRBtBCUM KYJ6GhRbRQ3eAaeyFhEg other-item contact-us"
              style="justify-content: space-between; padding-right: 0.2rem"
            >
              <div style="display: flex">
                <div
                  class="dDFOAjUKC5bZ6pGH7_p0 icon-wrap"
                  style="background: transparent"
                >
                  <svg-icon
                    className="bgcolor"
                    :style="{
                      color: SuporteIs
                        ? 'var(--theme-primary-color)'
                        : 'var(--theme-text-color-lighten)'
                    }"
                    icon-class="comm_icon_language--svgSprite:all"
                  />
                </div>

                <div class="_llZzyHSRes4dPHH7fN2">
                  {{
                    $store.state._i18nLocale == 'pt' ? 'Português' : 'English'
                  }}
                </div>
              </div>
              <svg-icon
                className="bgcolor_a"
                :style="{
                  color: SuporteIs
                    ? 'var(--theme-text-color-darken)'
                    : 'var(--theme-text-color-lighten)',
                  transform: SuporteIs ? 'rotate(-90deg)' : ''
                }"
                icon-class="comm_icon_sort--svgSprite:all"
              />
              <div v-if="SuporteIs" class="ant-popover-inner">
                <div
                  class="ant-menu-item"
                  @click="switchLang('pt')"
                  :style="{
                    color: `${
                      $store.state._i18nLocale == 'pt'
                        ? 'var(--theme-primary-color)'
                        : ''
                    }`
                  }"
                >
                  <span class="V4LeFhG0b9lZSmJT8Ynm switch-lang__text"
                    >Português</span
                  >
                </div>
                <div
                  class="ant-menu-item"
                  @click="switchLang('en')"
                  :style="{
                    color: `${
                      $store.state._i18nLocale == 'en'
                        ? 'var(--theme-primary-color)'
                        : ''
                    }`
                  }"
                >
                  <span class="V4LeFhG0b9lZSmJT8Ynm switch-lang__text"
                    >English</span
                  >
                </div>
              </div>
            </div>
            <div
              v-if="!hideAppDownload"
              class="yhSUVDFwjkr5PRBtBCUM KYJ6GhRbRQ3eAaeyFhEg other-item contact-us"
              @click="$store.commit('publicFun', ['AppDownload', true])"
            >
              <div class="dDFOAjUKC5bZ6pGH7_p0 icon-wrap">
                <svg-icon
                  className="bgcolor"
                  icon-class="icon_sy_zc_xz--svgSprite:all"
                />
              </div>
              <div class="_llZzyHSRes4dPHH7fN2">
                {{ $t('popup._BaixarApp') }}
              </div>
            </div>
            <div
              @click="$router.push({ name: 'notice' })"
              class="yhSUVDFwjkr5PRBtBCUM KYJ6GhRbRQ3eAaeyFhEg other-item contact-us"
            >
              <div class="dDFOAjUKC5bZ6pGH7_p0 icon-wrap">
                <svg-icon
                  className="bgcolor"
                  icon-class="icon_sy_zc_kf--svgSprite:all"
                />
              </div>
              <div class="_llZzyHSRes4dPHH7fN2">{{ $t('popup._Suporte') }}</div>
            </div>
            <div
              @click="$router.push({ name: 'notice' })"
              class="yhSUVDFwjkr5PRBtBCUM KYJ6GhRbRQ3eAaeyFhEg other-item contact-us"
            >
              <div class="dDFOAjUKC5bZ6pGH7_p0 icon-wrap">
                <svg-icon
                  className="bgcolor"
                  icon-class="icon_sy_zc_cjwt--svgSprite:all"
                />
              </div>
              <div class="_llZzyHSRes4dPHH7fN2">{{ $t('popup._FAQ') }}</div>
            </div>
            <!-- 'site_about' -->
            <div
              @click="
                $router.push({
                  name: 'details',
                  query: {
                    title: $t('popup._Sobre'),
                    isConter: true,
                    content: $store.state.config.site_about
                  }
                })
              "
              class="yhSUVDFwjkr5PRBtBCUM KYJ6GhRbRQ3eAaeyFhEg other-item contact-us"
            >
              <div class="dDFOAjUKC5bZ6pGH7_p0 icon-wrap">
                <svg-icon
                  className="bgcolor"
                  icon-class="icon_sy_zc_gywm--svgSprite:all"
                />
              </div>
              <div class="_llZzyHSRes4dPHH7fN2">{{ $t('popup._Sobre') }}</div>
            </div>
          </div>
          <div class="NQ4WM0y42kgXYhY5nCtm offical-channel">
            <p class="DBxipifklFUXsk1HBEsp">
              {{ $t('components._CanalOficial') }}
            </p>
            <ul class="VmQmq_aGsrNiKVkUlbUu">
              <li
                class="A_AasZeOJGaSJpKJubX7 channel-item"
                @click="openUrlCsusy(config.instagram)"
              >
                <img
                  src="https://cdntoos.w1-pegasopg.com/common/upload/1809372314179784705.png"
                  alt="."
                  data-blur="0"
                  data-status="loaded"
                  class="goDRiiBsuEuXD3W1NphN jmFqfEJv11xtlFSDmS9f"
                />
                <span class="QFyNFwV7f_hn4Tn_gwqJ channel-name">Instagram</span>
              </li>
              <li
                class="A_AasZeOJGaSJpKJubX7 channel-item"
                @click="openUrlCsusy(config.whatsapp)"
              >
                <img
                  src="https://cdntoos.w1-pegasopg.com/common/upload/1828565268666548226.png"
                  class="goDRiiBsuEuXD3W1NphN jmFqfEJv11xtlFSDmS9f"
                /><span class="QFyNFwV7f_hn4Tn_gwqJ channel-name"
                  >WhatsApp</span
                >
              </li>
            </ul>
          </div>
        </div>
      </div>
    </van-popup>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import {
  ICON_NAV,
  ICON_NAVActive,
  ICON_NAV3Dian6,
  ICON_NAV3Dian1,
  ICON_NAVActiveDian1
} from '@/assets/public/icon_nav.js';
import Audio from '@/components/audio/index.vue';
export default {
  name: 'Icon',
  computed: {
    ...mapState(['popList', 'userInfo', 'moneyInfo', 'config'])
  },
  components: {
    Audio
  },
  props: {
    showPopup: {
      type: Boolean,
      required: false
    }
  },
  data() {
    return {
      show: false,
      iconList: ICON_NAV,
      activeList: ICON_NAVActive,
      SuporteIs: false,
      _i18nLocale: '',
      is_vuex_token: false,
      hideAppDownload: window.localStorage.getItem('hideAppDownload')
    };
  },
  created() {
    let tempIconList = null;
    let tempActiveList = null;
    if (this._vuex_token && typeof this._vuex_token() == 'string') {
      this.is_vuex_token = true;
      if (this.config.ui_version == '3.1') {
        let demoIndex = 0;
        tempIconList = ICON_NAV3Dian1.filter((item, index) => {
          if (item.textName == '_Demo') demoIndex = index;
          return item.textName != '_Demo';
        });
        tempActiveList = ICON_NAVActiveDian1.filter((item, index) => {
          return index != demoIndex;
        });
        if (this.$t('popup.nav_31')[demoIndex].title == 'Demo') {
          this.$t('popup.nav_31').splice(demoIndex, 1);
        }
      }
    }
    if (this.config.ui_version == '3.6') {
      this.iconList = ICON_NAV3Dian6;
    }

    if (this.config.ui_version == '3.1') {
      this.iconList = tempIconList ?? ICON_NAV3Dian1;
      this.activeList = tempActiveList ?? ICON_NAVActiveDian1;
    }
    // this.$u.vuex('v_lang', item)
    // this._i18nLocale
    // console.log(this.$i18n.locale)
    // this.$i18n.locale = 'pt';
    // this.SuporteIs=false;
    // console.log(this.$store.state)
  },
  methods: {
    iconName() {
      return `${this.prefix}${this.name}`;
    },
    openUrlCsusy(e) {
      if (e != '#') {
        window.open(e, '_blank');
      }
    },
    switchLang(e = 'en') {
      this.$i18n.locale = e;
      this._i18n.locale = e;
      this.$vuex('_i18nLocale', e);
    },
    tabFun(index) {
      if (this.$t('popup.nav_31')[index].type == 'gorup') {
        window.open(this.$store.state.config.group_info.jump, '_blank');
        return;
      }

      this.$store.commit('active', index);
      this.$store.commit('showPopup', index);
    }
  }
};
</script>
<style>
.popup-box {
  top: 0.901rem !important;
  height: calc(100% - 0.901rem) !important;
}

.popup-box-app {
  top: 1.61rem !important;
  height: calc(100% - 1.61rem) !important;
}

.popup-conter {
  top: 0.9rem !important;
  height: calc(100% - 0.901rem) !important;
  background-color: var(--theme-main-bg-color) !important;
  max-width: 40% !important;
  bottom: 0;
}

html .popup-conter-app {
  /* top: 55% !important; */
  top: 1.61rem !important;
  height: calc(100% - 1.61rem) !important;
  background-color: var(--theme-main-bg-color) !important;
  max-width: 40% !important;
  bottom: 0;
  /* transform: initial; */
}

.popup-conter.van-popup--left,
.popup-conter-app.van-popup--left {
  transform: initial;
}
</style>
<style>
.van-popup {
  overflow-y: visible !important;
}
</style>
<style scoped>
._search-board_1lojg_30 {
  display: flex;
  align-items: center;
  margin: 0 0.15rem 0rem;
  height: 0.5rem;
  overflow: hidden;
  background-color: var(--theme-side-menu-btn-color);
  border-radius: 0.14rem;
}
._search-board_1lojg_30 ._text_1lojg_39 {
  flex: 1;
  margin-left: 0.18rem;
  color: var(--theme-text-color-lighten);
  font-size: 0.22rem;
}
.pendant-a1lbS {
  bottom: 0;
  height: 100%;
  left: 0;
  pointer-events: none;
  position: absolute;
  right: 0;
  top: 0;
  width: 100%;
  z-index: 2;
}

.pendant-lt-Pb8Fs,
.pendant-rb-trhWq {
  width: 0.4rem;
  height: 0.4rem;
  background-position: 0 0;
  background-size: 100% 100%;
  position: absolute;
}

.pendant-rb-trhWq {
  bottom: 0;
  right: 0;
}

.pendant-lt-Pb8Fs {
  top: 0;
  left: 0;
}

.searchWrap-AApaE {
  align-items: center;
  background-color: var(--cms-background-color-secondary);
  border-radius: 0.14rem;
  display: flex;
  height: 0.5rem;
  overflow: hidden;
  width: 100%;
  justify-content: space-between;
  padding-right: 0.18rem;
  color: var(--cms-text-color-secondary);
  font-size: 0.22rem;
  padding-left: 0.08rem;
}

.NQ4WM0y42kgXYhY5nCtm {
  margin: 0.2rem 0;
  width: 100%;
}

.NQ4WM0y42kgXYhY5nCtm .DBxipifklFUXsk1HBEsp {
  color: var(--theme-text-color-lighten);
  font-size: 0.24rem;
  font-stretch: normal;
  font-style: normal;
  font-weight: 400;
  letter-spacing: normal;
  line-height: 1.38;
  margin-bottom: 0.12rem;
  text-align: left;
}

.NQ4WM0y42kgXYhY5nCtm .VmQmq_aGsrNiKVkUlbUu {
  width: 100%;
}

.NQ4WM0y42kgXYhY5nCtm .VmQmq_aGsrNiKVkUlbUu .A_AasZeOJGaSJpKJubX7 {
  -ms-flex-align: center;
  -ms-flex-pack: start;
  align-items: center;
  background-color: var(--theme-side-menu-btn-color);
  border-radius: 0.1rem;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  display: -ms-flexbox;
  display: flex;
  justify-content: flex-start;
  margin-bottom: 0.1rem;
  padding: 0.08rem 0.18rem;
  width: 100%;
}

.NQ4WM0y42kgXYhY5nCtm
  .VmQmq_aGsrNiKVkUlbUu
  .A_AasZeOJGaSJpKJubX7
  .jmFqfEJv11xtlFSDmS9f {
  height: 0.34rem;
  width: 0.34rem;
}

.NQ4WM0y42kgXYhY5nCtm
  .VmQmq_aGsrNiKVkUlbUu
  .A_AasZeOJGaSJpKJubX7
  .QFyNFwV7f_hn4Tn_gwqJ {
  color: var(--theme-text-color-darken);
  font-size: 0.22rem;
  font-weight: 400;
  margin-left: 0.2rem;
  overflow: hidden;
  text-align: left;
  text-overflow: ellipsis;
  white-space: nowrap;
  width: 100%;
}

.my-scrollbar {
  height: 100%;
}

.X_tOtMUxMTenSfTn7J28 {
  -ms-flex-pack: justify;
  display: -ms-flexbox;
  display: flex;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
  justify-content: space-between;
  padding: 0.15rem 0.15rem 0;
}

.X_tOtMUxMTenSfTn7J28 .O8zRRZalAqyl6XRHwyev {
  -ms-flex-pack: distribute;
  background: var(--theme-side-menu-btn-color);
  border-radius: 0.1rem;
  color: var(--theme-text-color);
  cursor: pointer;
  display: -ms-flexbox;
  display: flex;
  -ms-flex-direction: column;
  flex-direction: column;
  height: 0.7rem;
  justify-content: space-around;
  margin-bottom: 0.1rem;
  width: 1rem;
}

.X_tOtMUxMTenSfTn7J28 .O8zRRZalAqyl6XRHwyev {
  border-radius: 0.14rem;
  cursor: pointer;
  font-size: 0.2rem;
  height: 0.9rem;
  max-width: 1.3rem;
  min-width: 1.3rem;
  width: 1.3rem;
}

.X_tOtMUxMTenSfTn7J28 .O8zRRZalAqyl6XRHwyev .JGYMaLsdGfKSq3qags9Y {
  height: 0.38rem;
  width: 0.5rem;
  margin: 0 auto;
}

.X_tOtMUxMTenSfTn7J28 .O8zRRZalAqyl6XRHwyev .IDcevVi1oQJGuthlvopy {
  font-size: 0.2rem;
  padding: 0 0.04rem;
  text-align: center;
  text-overflow: ellipsis;
  white-space: nowrap;
  width: 100%;
}

.X_tOtMUxMTenSfTn7J28 .O8zRRZalAqyl6XRHwyev.ia6woxHBwCJOiUSohzV6 {
  background-color: var(--theme-primary-color);
  background-position: 50%;
  background-size: 100% 100%;
  color: var(--theme-primary-font-color);
  position: relative;
  -webkit-transition: all 0.3;
  transition: all 0.3;
}

.vsmXMvkgXQ1ZupbTcU60 {
  padding: 0 0.15rem;
}

.JzmqmQEmD_EojrBge1qC {
  font-size: 0.24rem;
  height: 0.75rem;
  align-items: center;
  display: flex;
  justify-content: space-around;
  background-color: var(--theme-side-menu-btn-color);
  border-radius: 0.1rem;
  color: var(--theme-text-color);
  cursor: pointer;
  font-size: 0.24rem;
  margin-top: 0.1rem;
  width: 100%;
}

.JzmqmQEmD_EojrBge1qC_iam {
  width: 0.36rem;
  height: 0.36rem;
}

.yfF9WZOWUEDWBJAnHyPf {
  -ms-flex-pack: justify;
  background-color: var(--theme-side-menu-btn-color);
  border-radius: 0.1rem;
  display: -ms-flexbox;
  display: flex;
  box-sizing: border-box;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
  justify-content: space-between;
  margin: 0.1rem 0 0.05rem;
  padding: 0.1rem 0.1rem 0;
  width: 100%;
}

.a6z38LxCJRwWacRIx6d9 {
  color: var(--theme-text-color-lighten);
  font-size: 0.24rem;
  padding-bottom: 0.1rem;
  text-align: center;
  width: 2.5rem;
}

._037LxwuCKN9WUGgvrvgg {
  cursor: pointer;
  position: relative;
  margin-bottom: 0.1rem;
  width: 1.2rem;
  height: 0.8rem;
}

._037LxwuCKN9WUGgvrvgg img {
  position: absolute;
  top: 0;
  left: 0;
}

._037LxwuCKN9WUGgvrvgg span {
  position: absolute;
  left: 0.1rem;
  top: 0.06rem;
  font-size: 0.15rem;
  z-index: 9;
  color: #fff;
}

.other-group {
  margin-top: 0.1rem;
}

.contact-us {
  display: flex;
  color: var(--theme-text-color-lighten);
}

.bgcolor {
  color: var(--theme-side-menu-bg-color);
}

.bgcolor_a {
  color: var(--theme-side-menu-bg-color);
  width: 0.14rem !important;
  height: 0.14rem !important;
}

.dDFOAjUKC5bZ6pGH7_p0 {
  width: 0.36rem !important;
  height: 0.36rem !important;
  margin-right: 0.1rem;
  display: flex;
  height: 0.334rem;
  margin-right: 0.193rem;
  background: var(--theme-text-color-lighten);
  border-radius: 50%;
  width: 0.334rem;
}

._llZzyHSRes4dPHH7fN2 {
  font-size: 0.22rem;
}

.KYJ6GhRbRQ3eAaeyFhEg {
  cursor: pointer;
  font-size: 0.22rem;
  min-height: 0.6rem;
  display: flex;
  align-items: center;
  padding-left: 0.18rem;
}

.ant-popover-inner {
  background: var(--theme-main-bg-color);
  border: thin solid var(--theme-color-line);
  border-radius: 0.1rem;
  position: absolute;
  max-height: 4.7rem;
  right: -1.5rem;
}

.ant-popover-inner .ant-menu-item {
  font-size: 0.24rem;
  height: 0.8rem;
  line-height: 0.8rem;
  padding: 0 0.2rem;
}
</style>
